import Dice from './Dice';

export default Dice;
